import styled, { css } from "styled-components";

import { fontStyle } from "@pages/casino/assets/styles/mixins";

export const DropdownContainer = styled.div`
	position: relative;
	display: inline-block;
	width: max-content;
	cursor: pointer;
	min-width: 140px;

	@media (min-width: 1600px) {
		min-width: 200px;
	}
	${() =>
		window.HAS_LESS_BORDER_RADIUS &&
		css`
			${DropdownHeader} {
				border-radius: 10px;
				border: 1px solid #1f1f1f;
				background: #0c1011;
				color: #ececfb;
				font-size: 10px;
				font-weight: 400;
				line-height: 20px;
				letter-spacing: 0.3px;

				@media (min-width: 768px) {
					font-size: 12px;
					line-height: 12px;
					letter-spacing: 0.3px;
				}
				@media (min-width: 1600px) {
					font-size: 16px;
				}
			}
		`}
`;

export const DropdownHeader = styled.div`
	display: flex;
	height: 30px;
	min-width: max-content;
	text-transform: uppercase;
	width: 100%;
	padding: 0px 15px;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	position: relative;
	z-index: 20;
	border-radius: 20px;
	background: var(--casino-filter-button-bg);
	${fontStyle}
	transition: all 0.2s ease-in-out;
	color: var(--main-text-color);
	font-size: 12px;
	font-weight: 400;
	${() =>
		window.CASINO_FILTER_BUTTON_BORDERED &&
		css`
			border: 1px solid var(--main-text-color);
		`}

	@media (min-width: 1024px) {
		min-width: 140px;
		width: 140px;
	}

	@media (min-width: 1600px) {
		min-width: 200px;
		width: 200px;
		height: 40px;
	}

	&:hover {
		opacity: 0.7;
	}

	${({ open }) =>
		open &&
		css`
			background: linear-gradient(180deg, rgba(25, 23, 38, 1) 0%, rgba(5, 5, 18, 1) 100%);
		`};

	svg {
		transform: rotate(${(props) => (props.open ? "0deg" : "180deg")});
		transition: transform 0.2s ease-in-out;
	}

	p {
		margin: 0;
	}
`;

export const DropdownList = styled.div`
	display: ${(props) => (props.open ? "flex" : "none")};
	background: linear-gradient(180deg, rgb(25 23 38 / 87%) 0%, rgb(5 5 18 / 93%) 100%);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	flex-direction: column;
	min-width: calc(100% - 30px);
	align-items: center;
	padding-top: 20px;
	border-bottom-left-radius: 20px;
	border-bottom-right-radius: 20px;
	max-height: 300px;
	text-transform: uppercase;
	position: absolute;
	z-index: 10;
	top: 15px;
	padding-bottom: 16px;
	text-align: center;

	@media (min-width: 1024px) {
		min-width: 140px;
		width: 140px;
	}

	@media (min-width: 1600px) {
		min-width: 200px;
		width: 200px;
		padding-top: 40px;
	}
`;

export const DropdownScroll = styled.div`
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;

	&::-webkit-scrollbar-thumb {
		border-radius: 10px;
	}
`;

export const DropdownItem = styled.div`
	color: var(--main-text-color);
	text-decoration: none;
	display: flex;
	width: 100%;
	height: 30px;
	min-height: 30px;
	padding: 0px 20px;
	align-items: center;
	gap: 10px;
	${fontStyle}
	cursor: pointer;
	transition: background-color 0.2s ease-in-out;
	font-weight: 400;
	font-size: 10px;
	justify-content: center;
	text-align: center;

	@media (min-width: 768px) {
		font-weight: 400;
		font-size: 10px;
	}

	@media (min-width: 1600px) {
		font-size: 14px;
		height: 35px;
		line-height: 14px;
	}

	&:hover {
		border-radius: 20px;
		color: var(--main-color-light);
	}

	${({ isSelected }) =>
		isSelected &&
		css`
			color: var(--main-color-light);
		`};
`;

export const ModalItem = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px;
	letter-spacing: 0.75px;
	color: var(--main-text-color);
	text-decoration: none;
	display: flex;
	width: 100%;
	height: 40px;
	opacity: 0.7;
	justify-content: center;
	align-items: center;
	min-height: 40px;
	text-transform: uppercase;
	text-align: center;
	&:hover {
		opacity: 1;
	}

	${({ isSelected }) =>
		isSelected &&
		css`
			opacity: 1;
		`};

	@media (min-width: 1024px) {
		width: max-content;
	}
`;

export const FilterHeader = styled.div`
	align-items: center;
	display: flex;
	color: var(--secondary-text-color);
	justify-content: center;
	font-size: 16px;
	font-weight: 700;
	line-height: 40px;
	letter-spacing: 0.75px;
	margin-bottom: 10px;
	position: relative;

	span {
		color: var(--secondary-text-color);
		font-size: 10px;
		font-weight: 600;
		line-height: 10px;
		letter-spacing: 0.3px;
		border-radius: 20px;
		background: var(--main-explosive-gradient);
		display: flex;
		min-width: 25px;
		height: 25px;
		justify-content: center;
		align-items: center;
		margin-left: 5px;
	}
`;

export const ModalItemsWrapper = styled.div`
	display: flex;
	flex-direction: column;

	.modal-close-icon {
		bottom: 90px;
		cursor: pointer;
		border-radius: 25px;
		border: 1px solid var(--border-bg-color);
		background: var(--modal-bg);
		width: 50px;
		height: 50px;
		transform: rotate(90deg);
		justify-content: center;
		padding: 10px;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
		position: fixed;
		left: 50%;
		transform: translateX(-50%);
		z-index: 99;

		@media (min-width: 1024px) {
			bottom: 60px;
		}
	}

	.payment {
		bottom: 10px;
	}

	@media (min-width: 1024px) {
		width: 100%;
		max-width: 1230px;
	}
`;

export const ItemWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(0, 285px));
	grid-gap: 10px;
	max-height: 100vh;
	overflow-y: auto;
	justify-items: center;
	max-width: 1230px;
	margin: 0 auto;
	justify-content: center;
	padding-bottom: 230px;

	@media (min-width: 1024px) {
		max-height: 100vh;
		column-gap: 30px;
		flex-wrap: wrap;
		align-content: space-between;
		width: 100%;
		align-items: center;
		padding-bottom: 300px;
	}

	${({ isSearchOpen }) =>
		isSearchOpen &&
		css`
			margin-top: 20px;

			@media (min-width: 1024px) {
				padding-bottom: 370px;
			}
		`};

	${({ isPaymentPage }) =>
		isPaymentPage &&
		css`
			display: flex;
			flex-direction: column;
			gap: 10px;

			@media (min-width: 1024px) {
				flex-wrap: nowrap;
			}
		`}
`;

export const SearchButton = styled.div`
	position: absolute;
	right: 0;
	display: flex;
	border: 1px solid var(--border-bg-color);
	border-radius: 50%;
	width: 40px;
	height: 40px;
	align-items: center;
	justify-content: center;

	svg {
		path {
			fill: #6e7191;
		}
	}
`;

export const InfoText = styled.p`
	font-size: 10px;
	font-style: normal;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.25px;
	padding: 10px 0;
	color: var(--main-text-color);
	margin: 0 auto;

	@media (min-width: 1440px) {
		line-height: 14.963px;
		letter-spacing: 0.312px;
		font-size: 14px;
	}
`;

export const CloseIconOverlay = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 214px;
	background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 100%);
	z-index: 9;
	pointer-events: none;
`;

export const SearchContainer = styled.div`
	display: flex;
	width: 300px;
	height: 40px;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	padding: 10px 20px;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	margin: 0 auto;

	${(props) =>
		!props.isBottomRadius &&
		"border-bottom-left-radius: 20px;border-bottom-right-radius: 20px;"}
	background-color: var(--dark);
	${({ noValue, hasItem }) =>
		!noValue
			? hasItem
				? css`
						border-top: 1px solid var(--Green-dark, #067306);
						border-bottom: 1px solid var(--Green-dark, #067306);
					`
				: css`
						border-top: 1px solid var(--Red-dark, #940136);
						border-bottom: 1px solid var(--Red-dark, #940136);
					`
			: css`
					border-top: 1px solid var(--main-color-dark);
					border-bottom: 1px solid var(--main-color-dark);
				`};

	@media (min-width: 425px) {
		width: 350px;
	}

	@media (min-width: 768px) {
		width: 438px;
	}

	@media (min-width: 1024px) {
		width: 584px;
	}

	@media (min-width: 1440px) {
		height: 50px;
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
		${(props) =>
			!props.isBottomRadius &&
			"border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;"}
	}

	@media (min-width: 1600px) {
		width: 720px;
	}

	.search-input-trash-icon {
		cursor: pointer;
	}

	input {
		padding: 0 10px;
		width: 100%;
		height: 40px;
		border: none;
		border: none;
		outline: none;
		color: var(--main-text-color);
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		background-color: transparent;
		&::placeholder {
			color: var(--main-text-color);
			opacity: 1; /* Firefox */
		}

		&::-ms-input-placeholder {
			/* Edge 12 -18 */
			color: var(--main-text-color);
		}
		@media (min-width: 1440px) {
			height: 50px;
			font-size: 15px;
			font-style: normal;
			font-weight: 600;
			line-height: 24.938px; /* 166.251% */
			letter-spacing: 0.374px;
		}
	}

	svg {
		@media (min-width: 1440px) {
			width: 32px;
			height: 32px;
		}
	}
`;
